import { Outlet } from 'react-router-dom';
import Navbar from '../navbar';
import styles from './styles';
import cookiesManager from '../../utils/cookies';
import { AUTH_KEYS, USER_DATA } from '../../utils/cookies/keys';
import { useEffect } from 'react';
import { handleLogout } from '../../utils/logout';
import { PermissionProvider } from '../../permissions/permissionContext';
import { useGetUserAssignedCities } from '../../api/hooks/user-cities';

const ProtectedRoute = () => {
  const accessToken = cookiesManager.get(AUTH_KEYS.ACCESS_TOKEN);
  const refreshToken = cookiesManager.get(AUTH_KEYS.REFRESH_TOKEN);
  const isAuthenticated = !!accessToken && !!refreshToken;

  const { getUserAssignedCitiesMutation } = useGetUserAssignedCities({
    onSuccess: cities => {
      cookiesManager.set(
        USER_DATA.ASSIGNED_CITIES,
        JSON.stringify(cities),
      );
    },
  });

  useEffect(() => {
    if (!isAuthenticated) {
      handleLogout();
      return;
    }
    const storedCities = cookiesManager.get(USER_DATA.ASSIGNED_CITIES);
    if (!storedCities) {
      getUserAssignedCitiesMutation();
    }
  }, [isAuthenticated, getUserAssignedCitiesMutation]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <PermissionProvider>
      <div>
        <Navbar />
        <main css={styles.mainContainer}>
          <div css={styles.outletBody}>
            <Outlet />
          </div>
        </main>
      </div>
    </PermissionProvider>
  );
};

export default ProtectedRoute;
